export const licenceTypes = [

"General",

"Practising",

"Temporary",

"Provisional",

"Emergency",

"Restricted",

"Educational",

"Non-Practising"

];